import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import "./index.scss";
import { useSelector, useDispatch } from "react-redux";
import { useGetUserDataQuery } from "../../services/login";
import { useFetchQuery } from "../../services/cart";
import { useGetShippingAddressesQuery } from "../../services/login";
import { useCreateCheckoutMutation } from "../../services/checkout";
import Host from "../../Components/Host";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/joy/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/joy/Button";
import FooterText from "../../Components/CheckoutComponent/FooterText";

// checkout modules
import GuestShippingAddress from "../../Components/CheckoutComponent/GuestShippingAddress";
import ShippingAddress from "../../Components/CheckoutComponent/ShippingAddress";
import CartItems from "../../Components/CheckoutComponent/CartItems";
import CartIInformation from "../../Components/CheckoutComponent/CartIInformation";
import TapTabbyCheckout from "../../Components/CheckoutComponent/TapTabbyCheckout";
import PayByApplePay from "../../Components/CheckoutComponent/PayByApplePay";
import TapCardCheckout from "../../Components/CheckoutComponent/TapCardCheckout";
import PayByCardPay from "../../Components/CheckoutComponent/PayByCardPay";
import ZiinaApplePay from "../../Components/CheckoutComponent/ZiinaApplePay";
import ConfirmCheckout from "../../Components/CheckoutComponent/ConfirmCheckout";
import MyFatoorahApplePay from "../../Components/CheckoutComponent/MyFatoorahApplePay";

//currencies module
const tapCurrencies = ["SAR", "BHD", "EGP", "EUR", "GBP", "KWD", "OMR", "QAR"];
const payByCurrencies = ["AED"];
const tabbyCurrencies = ["AED", "SAR"];
const allCurrencies = ["SAR", "BHD", "EGP", "EUR", "GBP", "KWD", "OMR", "QAR", "AED"];

function CheckoutPage() {
  const { userId, userToken, userEmail, countryCode, cartToken, languageCode, guestShippment } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const isAction = new URLSearchParams(location.search).get("action") || "default";
  const tapId = new URLSearchParams(location.search).get("tap_id") || null;
  const orderId = new URLSearchParams(location.search).get("order_id") || null;
  const orderToken = new URLSearchParams(location.search).get("order_token") || null;
  const couponCode = new URLSearchParams(location.search).get("coupon") || null;
  const userParams = { userId: userId, userToken: userToken, countryCode: countryCode };
  const [getSelectShipmentAddressId, setSelectShipmentAddressId] = React.useState();
  const ShippingInfo = useGetShippingAddressesQuery(userParams, { refetchOnMountOrArgChange: true, skip: !userId });
  const ShippingData = ShippingInfo?.data?.shipping_addresses;
  const selectedShipping = ShippingData?.find((s) => s.id === getSelectShipmentAddressId);
  const { data: userData } = useGetUserDataQuery(userParams, { refetchOnMountOrArgChange: true });
  const currency = userData?.contant?.currency;
  const {
    data: cartInfo,
    isLoading,
    isFetching,
    refetch,
  } = useFetchQuery({ coupon: couponCode, cartToken: cartToken, ...userParams }, { refetchOnMountOrArgChange: true });
  const cartData = cartInfo?.cart;
  const thisToken = cartInfo?.token;
  const couponData = cartInfo?.coupon;

  const [getTestLoading, setTestLoading] = useState(false);
  const [checkoutData, setCheckoutData] = React.useState({});
  const [getCardCheckoutData, cardCheckoutData] = React.useState({});
  const [isTabbySelected, tabbySelected] = React.useState(false);
  const [isApplePaySelected, applepayselected] = React.useState(false);
  const [isZiinaApplePaySelected, setZiinaApplePaySelected] = React.useState(false);
  const [isZiinaApplePaySelected2, setZiinaApplePaySelected2] = React.useState(false);

  const [isFatoorahAppleSelected, setFatoorahAppleSelected] = React.useState(false);
  const [isFatoorahGoogleSelected, setFatoorahGoogleSelected] = React.useState(false);
  const [isFatoorahCardSelected, setFatoorahCardSelected] = React.useState(false);

  const [isSavedCardSelected, savedcardselected] = React.useState(false);
  const [isPayByCardSelected, paybycardselected] = React.useState(false);
  const [isCardSelected, cardselected] = React.useState(false);
  const [getValidInput, setValidInput] = React.useState(false);

  const [getPayByIframe, setPayByIframe] = React.useState(false);
  const [getIframeMessage, setIframeMessage] = React.useState("");

  function closePayByIframe() {
    setPayByIframe(false);
  }

  // call checkout action
  const [createcheckout, checkoutResult] = useCreateCheckoutMutation();

  useEffect(() => {
    if (checkoutResult?.isSuccess) {
      setTestLoading(true);

      const responseData = checkoutResult?.data?.data;
      const tokenUrl =
        responseData?.transaction?.url ||
        responseData?.body?.interActionParams?.tokenUrl ||
        responseData?.redirect_url ||
        responseData?.checkout_url ||
        responseData?.Data?.PaymentURL;

      if (checkoutData?.payment_by === "payby_cards") {
        try {
          PayBy.createIframe({
            id: "container-checkout-test",
            lang: "en",
            tokenUrl: tokenUrl,
            error: function (msg) {
              setIframeMessage(msg);
            },
          });
        } catch (error) {
          setIframeMessage(error);
        }
      } else {
        window.location.href = tokenUrl;
      }

      setTestLoading(false);
    }
    if (checkoutResult?.isError) {
      setPayByIframe(false);
      setTestLoading(false);
    }
  }, [checkoutResult, checkoutResult?.isSuccess, getTestLoading]);

  useEffect(() => {
    if (guestShippment?.name) {
      refetch();
    }
    if (selectedShipping?.name) {
      refetch();
    }
  }, [guestShippment, ShippingInfo]);

  const TotalPrice = cartData?.reduce((accumulator, value) => {
    const productPrice = value.prices?.value * value.quantity;
    return accumulator + productPrice;
  }, 0);

  // checkout payload
  const userInformation =
    userId && userToken
      ? {
          userId: userId,
          userToken: userToken,
          userEmail: userEmail,
          customer_name: selectedShipping?.name,
          customer_email: userEmail,
          payment_mode: "user",
          customer_phone: selectedShipping?.phone,
        }
      : {
          customer_name: guestShippment?.name,
          customer_email: guestShippment?.email,
          userEmail: guestShippment?.email,
          payment_mode: "guest",
          customer_phone: guestShippment?.phone,
        };

  const [isShippingAddress, setShippingAddress] = useState({});
  useEffect(() => {
    if (selectedShipping?.name) {
      setShippingAddress({
        address: selectedShipping?.address,
        city: selectedShipping?.city,
        city_code: selectedShipping?.city_code,
        country: selectedShipping?.country,
        country_code: selectedShipping?.country_code,
        email: selectedShipping?.email,
        name: selectedShipping?.name,
        phone: selectedShipping?.phone,
        street: selectedShipping?.street,
        zip_code: selectedShipping?.zip_code,
      });
    } else {
      setShippingAddress({
        address: guestShippment?.address,
        city: guestShippment?.city,
        city_code: guestShippment?.city_code,
        country: guestShippment?.country,
        country_code: guestShippment?.country_code,
        email: guestShippment?.email,
        name: guestShippment?.name,
        phone: guestShippment?.phone,
        street: guestShippment?.street,
        zip_code: guestShippment?.zip_code,
      });
    }
  }, [selectedShipping?.name, guestShippment?.name, isShippingAddress?.name]);

  const phoneNumber = userInformation?.customer_phone || "";
  const parsedNumber = parsePhoneNumberFromString(phoneNumber);
  const countryPhoneCode = parsedNumber?.countryCallingCode;
  const countryPhoneNumber = parsedNumber?.nationalNumber;

  const checkoutPayload = {
    shipping_address: isShippingAddress,
    shipping_address_id: getSelectShipmentAddressId,
    language: languageCode,
    country: countryCode,
    countryCode: countryCode,
    currency: cartData?.[0]?.prices?.currency,
    amount: couponData ? Number(TotalPrice) - Number(couponData?.discount) : Number(TotalPrice),
    shipping_price: Number(userData?.contant?.standard_delivery),
    delivery_days: Number(userData?.contant?.delivery_days),
    products: cartData,
    cartToken: cartToken,
    domainName: Host?.domainName,
    domain: window.location.hostname,
    domainEmail: Host?.email,
    token: thisToken,
    coupon: couponData ? couponData : null,
    payment_by: checkoutData?.payment_by,
    tabby_id: checkoutData?.tabby_id,
    card_id: checkoutData?.card_id,
    customer_id: checkoutData?.customer_id,
    countryPhoneCode: countryPhoneCode,
    countryPhoneNumber: countryPhoneNumber,
    customer: userData?.user?.customer,
    data: getCardCheckoutData?.id ? getCardCheckoutData : { id: checkoutData?.tabby_id },
    ...userInformation,
  };

  let checkoutButtonDisabled = true;
  if (isSavedCardSelected) {
    checkoutButtonDisabled = false;
  } else if (isApplePaySelected) {
    checkoutButtonDisabled = false;
  } else if (isZiinaApplePaySelected) {
    checkoutButtonDisabled = false;
  } else if (isZiinaApplePaySelected2) {
    checkoutButtonDisabled = false;
  } else if (isFatoorahAppleSelected) {
    checkoutButtonDisabled = false;
  } else if (isFatoorahGoogleSelected) {
    checkoutButtonDisabled = false;
  } else if (isFatoorahCardSelected) {
    checkoutButtonDisabled = false;
  } else if (isTabbySelected) {
    checkoutButtonDisabled = false;
  } else if (getValidInput) {
    checkoutButtonDisabled = false;
  } else if (isPayByCardSelected) {
    checkoutButtonDisabled = false;
  } else if (isPayByCardSelected) {
    checkoutButtonDisabled = false;
  }

  const isShipmentAddress =
    userId && userToken ? (getSelectShipmentAddressId ? false : true) : guestShippment?.email ? false : true;

  // Tap card sdk checkout and checkout button action
  const proceedeToCheckout = async () => {
    if (!isShippingAddress?.name) {
      return alert("Please add a shipping address.");
    } else if (isShipmentAddress) {
      return alert("Please select a shipping address.");
    }

    if (checkoutButtonDisabled) return alert("Please select a payment method.");

    if (isCardSelected && getValidInput) {
      setTestLoading(true);
      if (window.CardSDK && typeof window.CardSDK.tokenize === "function") {
        setTestLoading(true);
        await window.CardSDK.tokenize();
      } else {
        console.error("CardSDK or CardSDK.tokenize() is not available.");
        setTestLoading(false);
      }
    }

    // saved card checkout
    if (isSavedCardSelected && checkoutData?.card_id) {
      createcheckout(checkoutPayload);
    }

    // tap tabby checkout
    if (isTabbySelected && checkoutData?.tabby_id) {
      createcheckout(checkoutPayload);
    }

    // tap tabby checkout
    if (isApplePaySelected) {
      createcheckout(checkoutPayload);
    }

    if (isZiinaApplePaySelected) {
      createcheckout(checkoutPayload);
    }
    if (isZiinaApplePaySelected2) {
      createcheckout(checkoutPayload);
    }

    if (isFatoorahAppleSelected) {
      createcheckout(checkoutPayload);
    }

    if (isFatoorahGoogleSelected) {
      createcheckout(checkoutPayload);
    }

    if (isFatoorahCardSelected) {
      createcheckout(checkoutPayload);
    }

    if (isPayByCardSelected) {
      setPayByIframe(true);
      createcheckout(checkoutPayload);
    }
  };

  // new card checkout
  useEffect(() => {
    if (isCardSelected && getCardCheckoutData?.id && getCardCheckoutData?.card?.id) {
      createcheckout(checkoutPayload);
    }
  }, [getCardCheckoutData]);

  function checkoutWithTapTabby(data) {
    refetch();
    setCheckoutData(data);
    tabbySelected(data.selected);
    applepayselected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithPayByApple(data) {
    refetch();
    setCheckoutData(data);
    applepayselected(data.selected);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithZiinaApple(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected(data.selected);
    setZiinaApplePaySelected2(false);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithFatoorahApple(data) {
    refetch();
    setCheckoutData(data);
    setFatoorahAppleSelected(data.selected);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
  }

  function checkoutWithFatoorahGoogle(data) {
    refetch();
    setCheckoutData(data);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(data.selected);
    setFatoorahCardSelected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
  }

  function checkoutWithFatoorahCard(data) {
    refetch();
    setCheckoutData(data);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(data.selected);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
  }

  function checkoutWithZiinaApple2(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected2(data.selected);
    setZiinaApplePaySelected(false);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    paybycardselected(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithPayByCard(data) {
    refetch();
    setCheckoutData(data);
    paybycardselected(data.selected);
    applepayselected(false);
    tabbySelected(false);
    savedcardselected(false);
    cardselected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithSavedCard(data) {
    refetch();
    setCheckoutData(data);
    savedcardselected(data.selected);
    tabbySelected(false);
    applepayselected(false);
    cardselected(false);
    paybycardselected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function checkoutWithCard(data) {
    refetch();
    setCheckoutData(data);
    cardselected(data.selected);
    savedcardselected(false);
    tabbySelected(false);
    applepayselected(false);
    paybycardselected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setFatoorahAppleSelected(false);
    setFatoorahGoogleSelected(false);
    setFatoorahCardSelected(false);
  }

  function processingLoading(loading, loading2) {
    if (loading) {
      return true;
    } else if (loading2) {
      return true;
    } else {
      return false;
    }
  }

  const [isPaymentSwitchModal, setPaymentSwitchModal] = useState(false);
  useEffect(() => {
    if (isAction === "retry") {
      setPaymentSwitchModal(false);
    }
  }, []);
  function closePaymentSwitchModal() {
    setPaymentSwitchModal(false);
  }

  function tryAgainAction() {
    history.push("/purchase");
    setPaymentSwitchModal(false);
  }
  function okayAction() {
    setPaymentSwitchModal(false);
  }

  useEffect(() => {
    if (window.location.pathname === "/purchase" || window.location.pathname === "/en/purchase") {
      const style = document.createElement("style");
      const style2 = document.createElement("style");
      const style3 = document.createElement("style");
      style.innerHTML = `
      .circleChatButtonWrap {
        display: none !important;
      }
    `;
      style2.innerHTML = `
      .circleContactButtonWrap {
        display: none !important;
      }
    `;
      style3.innerHTML = `
      body {
        background: #F8F8F8 !important;
      }
    `;

      document.head.appendChild(style);
      document.head.appendChild(style2);
      document.head.appendChild(style3);

      return () => {
        document.head.removeChild(style);
        document.head.removeChild(style2);
        document.head.removeChild(style3);
      };
    }
  }, [window.location.pathname]);

  return (
    <div className="Purchase-page">
      <div className="container purchase-container">
        <div className="row purchase-section" style={{ position: "relative" }}>
          {orderId && orderToken && <ConfirmCheckout tapId={tapId} orderId={orderId} orderToken={orderToken} />}

          <Modal
            className="country-modal p-switch-"
            show={isPaymentSwitchModal}
            onHide={closePaymentSwitchModal}
            centered
            animation={false}
            backdrop="static"
          >
            <Modal.Body style={{ padding: "20px" }}>
              <div className="row">
                <div className="col-md-12">
                  <div style={{ textAlign: "center", color: "rgb(211, 47, 47)" }}>
                    <p>Having issues with making payments? Try using an alternate payment gateway.</p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    <Button
                      variant="outlined"
                      size="sm"
                      onClick={() => okayAction()}
                      color="primary"
                      style={{ textTransform: "capitalize", fontWeight: 500 }}
                    >
                      Okay
                    </Button>
                    <Button
                      onClick={() => tryAgainAction()}
                      variant="outlined"
                      size="sm"
                      color="warning"
                      component={Link}
                      to={`/purchase`}
                      style={{
                        textTransform: "capitalize",
                        fontWeight: 500,
                      }}
                    >
                      Try Again
                    </Button>
                  </div>
                </div>
                <br />
              </div>
            </Modal.Body>
          </Modal>

          {!orderId && !orderToken && (
            <>
              {processingLoading(getTestLoading, checkoutResult?.isLoading) && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    left: 0,
                    top: 0,
                    zIndex: 999,
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                    background: "#ffffffab",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ marginBottom: "10px", color: "#000", display: "flex", alignItems: "center" }}>
                      Processing please wait!
                    </div>
                    <CircularProgress style={{ width: "2rem", height: "2rem", color: "#fe7f4a" }} />
                  </div>
                </div>
              )}

              <div className="col-md-6 p0">
                <div className="row">
                  {!userId && !userToken && <GuestShippingAddress />}
                  {userId && userToken && (
                    <ShippingAddress
                      ShippingInfo={ShippingInfo}
                      getSelectShipmentAddressId={getSelectShipmentAddressId}
                      setSelectShipmentAddressId={setSelectShipmentAddressId}
                    />
                  )}
                  {cartData?.length > 0 && (
                    <div className="col-md-12 pp-padding" style={{ padding: 0 }}>
                      <div className="cp-cinfo-card">
                        <div
                          style={{
                            marginBottom: "15px",
                            gap: "5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                          }}
                        >
                          <span className="alert-text">{t("select_payment_method")}</span>
                          <span style={{ fontSize: "12px" }}>
                            {isAction === "retry" ? "Powered by myfatoorah" : "Powered by ziina"}
                            {/* {"Powered by ziina"} */}
                          </span>
                        </div>
                        {/* {tabbyCurrencies?.includes(currency) &&
                          <TapTabbyCheckout
                            cartInfo={cartInfo}
                            userData={userData}
                            guestShippment={guestShippment}
                            getSelectShipmentAddressId={getSelectShipmentAddressId}
                            checkoutWithTapTabby={checkoutWithTapTabby}
                            isTabbySelected={isTabbySelected}
                            isShipmentAddress={isShipmentAddress}
                          />
                        } */}

                        {/* {payByCurrencies?.includes(currency) &&
                          <>
                            {window.ApplePaySession &&
                              <PayByApplePay
                                cartInfo={cartInfo}
                                userData={userData}
                                guestShippment={guestShippment}
                                getSelectShipmentAddressId={getSelectShipmentAddressId}
                                checkoutWithPayByApple={checkoutWithPayByApple}
                                isApplePaySelected={isApplePaySelected}
                                isShipmentAddress={isShipmentAddress}
                              />
                            }
                          </>
                        } */}

                        {allCurrencies?.includes(currency) && isAction === "retry" && (
                          <MyFatoorahApplePay
                            checkoutWithFatoorahApple={checkoutWithFatoorahApple}
                            checkoutWithFatoorahGoogle={checkoutWithFatoorahGoogle}
                            checkoutWithFatoorahCard={checkoutWithFatoorahCard}
                            isFatoorahAppleSelected={isFatoorahAppleSelected}
                            isFatoorahGoogleSelected={isFatoorahGoogleSelected}
                            isFatoorahCardSelected={isFatoorahCardSelected}
                            isShipmentAddress={isShipmentAddress}
                          />
                        )}

                        {allCurrencies?.includes(currency) && isAction === "default" && (
                        <ZiinaApplePay
                          isShipmentAddress={isShipmentAddress}
                          isZiinaApplePaySelected={isZiinaApplePaySelected}
                          isZiinaApplePaySelected2={isZiinaApplePaySelected2}
                          checkoutWithZiinaApple={checkoutWithZiinaApple}
                          checkoutWithZiinaApple2={checkoutWithZiinaApple2}
                        />
                        )}

                        <div
                          className="cp-pm-button-card"
                          style={{
                            display: "block",
                            textAlign: "center",
                            width: "100%",
                            padding: "7px 10px 7px 20px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <div style={{ fontSize: "12px", color: "#000", textAlign: "left" }}>
                              Having issues with making payments? Try using an alternate payment gateway.
                            </div>
                            <Button
                              style={{ minHeight: "28px", maxHeight: "28px", fontWeight: 500 }}
                              variant="outlined"
                              size="sm"
                              component={Link}
                              to={isAction === "default" ? `/purchase?action=retry` : `/purchase`}
                            >
                              <div>Switch</div>
                            </Button>
                          </span>
                        </div>

                        {/* {payByCurrencies?.includes(currency) &&
                          // <PayByCardPay
                          //   cartInfo={cartInfo}
                          //   userData={userData}
                          //   guestShippment={guestShippment}
                          //   getSelectShipmentAddressId={getSelectShipmentAddressId}
                          //   checkoutWithPayByCard={checkoutWithPayByCard}
                          //   isPayByCardSelected={isPayByCardSelected}
                          //   isShipmentAddress={isShipmentAddress}
                          // />
                        } */}

                        <Modal
                          className="pay-purchase-dialogue"
                          show={getPayByIframe}
                          onHide={closePayByIframe}
                          centered
                          animation={false}
                        >
                          <Modal.Body>
                            <IconButton
                              style={{ cursor: "pointer", position: "absolute", right: "5px", top: "5px", zIndex: 111 }}
                              onClick={closePayByIframe}
                            >
                              <CloseIcon className="Header-close-modal-icon" />
                            </IconButton>
                            {checkoutResult?.isLoading && (
                              <div
                                style={{
                                  height: "450px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <CircularProgress style={{ width: "2rem", height: "2rem", color: "#fe7f4a" }} />
                              </div>
                            )}

                            {getIframeMessage && (
                              <div
                                className="alert alert-danger"
                                style={{ background: "#fff0", border: "none", margin: 0, padding: "20px" }}
                              >
                                {getIframeMessage}
                              </div>
                            )}
                            {checkoutResult?.isSuccess && (
                              <div style={{ height: "500px" }} id="container-checkout-test"></div>
                            )}
                          </Modal.Body>
                        </Modal>

                        {/* {tapCurrencies?.includes(currency) &&
                          <TapCardCheckout
                            cartInfo={cartInfo}
                            userData={userData}
                            isShipmentAddress={isShipmentAddress}
                            checkoutWithSavedCard={checkoutWithSavedCard}
                            checkoutData={checkoutData}
                            isSavedCardSelected={isSavedCardSelected}
                            checkoutWithCard={checkoutWithCard}
                            isCardSelected={isCardSelected}
                            setValidInput={setValidInput}
                            countryPhoneCode={countryPhoneCode}
                            countryPhoneNumber={countryPhoneNumber}
                            customerName={userInformation?.customer_name}
                            cardCheckoutData={cardCheckoutData}
                          />
                        } */}
                      </div>
                    </div>
                  )}
                </div>
                <br />
              </div>

              <div className="col-md-5 pp-padding">
                <div className="row">
                  <div className="col-md-12 pp-padding" style={{ padding: 0 }}>
                    <div className="cp-cinfo-card " style={{ marginBottom: "10px" }}>
                      <CartItems
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        checkoutResult={checkoutResult}
                      />

                      <CartIInformation
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        proceedeToCheckout={proceedeToCheckout}
                        couponData={couponData}
                        checkoutResult={checkoutResult}
                      />
                    </div>
                  </div>
                  <FooterText />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

export default CheckoutPage;
